if (!customElements.get('piecework-view-buttons')) {
  customElements.define(
    'piecework-view-buttons',
    class PieceworkViewButtons extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          buttons: this.querySelectorAll('.pw-view-by-button'),
          grid: document.querySelector('.product-grid-container'),
        };

        if (!this.elements.buttons || !this.elements.grid) return;

        this.elements.buttons.forEach((e) => {
          const type = e.dataset.viewby;
          e.addEventListener('click', this.changeImageType.bind(this, type));
        });
      }

      changeImageType(type) {
        this.elements.grid.dataset.viewby = type;
        this.elements.buttons.forEach((e) => {
          if (e.dataset.viewby === type) {
            e.classList.add('pw-viewby-active');
          } else {
            e.classList.remove('pw-viewby-active');
          }
        });
        localStorage.setItem('pw-viewby', type);
      }

      connectedCallback() {
        const validTypes = Array.from(this.elements.buttons).map((e) => e.dataset.viewby);
        const localViewType = localStorage.getItem('pw-viewby');
        // Default comes from the collection's use_gift_image metafield, rendered by Liquid
        // onto the grid's data-viewby attribute. Fall back to the first button.
        const defaultViewType =
          (this.elements.grid && this.elements.grid.dataset.viewby) ||
          this.elements.buttons[0].dataset.viewby;

        if (localViewType && validTypes.includes(localViewType)) {
          this.changeImageType(localViewType);
        } else {
          this.changeImageType(defaultViewType);
        }
      }
    }
  );
}